<template>
	<div
		@click="editStepSetup"
		v-if="selectedProfile"
		class="profile-and-asnyc-container px-6 flex flex-row flex-align-center flex-justify-space-between"
	>
		<div>{{ selectedProfile.connection_name }}</div>
		<div
			v-if="asyncRunAfterAllPrevious || asyncRunBeforeAllFollowing"
			class="async-indicator-container display-flex flex-row flex-justify-space-around flex-align-center px-2"
		>
			I-Async
			<SIcon name="async-down" v-if="asyncRunAfterAllPrevious" />
			<SIcon name="async-up" v-if="asyncRunBeforeAllFollowing" />
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getAllAccountConnections } from '@/store/modules/credentials/getters';

import BlockEditorService from '../block-editor-service';

export default {
	name: 'ProfileAndAsyncHeader',
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		asyncRunBeforeAllFollowing() {
			return this.editNode.async_before_all_following_flag;
		},
		asyncRunAfterAllPrevious() {
			return this.editNode.async_run_after_all_previous_flag;
		},
		...mapGetters(['apps/getCredentialsForService', getAllAccountConnections.fullPath]),
		profileItemsList() {
			return this['apps/getCredentialsForService'](this.editNode.service);
		},
		selectedProfile() {
			const allProfiles = this.profileItemsList || [];
			return allProfiles.find((item) => item.id === this.editNode.credentials_configuration.credentials);
		},
	},
	methods: {
		editStepSetup() {
			if (this.selectedProfile) {
				const stepSetUp = BlockEditorService.getStepDropdownMenuItems().find((item) => item.id === 'edit_step_setup');
				this.$emit('itemClicked', stepSetUp);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.profile-and-asnyc-container {
	height: 50px;
	font-size: 12px;
	cursor: pointer;
	color: var(--primary-font-color);
	border-bottom: 1px solid var(--border-color);

	.async-indicator-container {
		width: 85px;
		height: 18px;
		border-radius: 8px;
		color: var(--subtle-font-color);
		border: 1px solid var(--subtle-font-color);
	}
}
</style>
